/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
  messageType,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (messageType) {
      payload.append('message_type', messageType);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };
    if (messageType) {
      payload.message_type = messageType;
    }
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
    messageType,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
        messageType,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  moderateComment(conversationId, messageId, moderationAction) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/moderate_comment`,
      {
        moderation_action: moderationAction,
      }
    );
  }

  saveAudioTranscription(
    conversationId,
    messageId,
    attachmentId,
    transcribedText
  ) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/transcription`,
      {
        attachment_id: attachmentId,
        transcribed_text: transcribedText,
      }
    );
  }

  retryVoiceRecording(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/voice_recording_retry`
    );
  }

  requestVoiceTranscription(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/voice_transcription`
    );
  }

  getVoiceTranscription(conversationId, messageId) {
    return axios.get(
      `${this.url}/${conversationId}/messages/${messageId}/voice_transcription`
    );
  }
}

export default new MessageApi();
